module.exports = __webpack_public_path__ + "static/media/PSLDisplayPro.1d6d7148.woff";